import React from 'react';
import ReactDOM from 'react-dom';
// import Rx from 'rxjs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';

import Logger from '../../../../../UmiCore/src/Logger';
import richText from '../plugins/RichTextApp';
import DateUtils from '../utils/DateUtils';
import SpecialUtils from '../utils/SpecialUtils';


/**
 * Notas:
 * ---
 * Para entender el flujo de renderizado del mensaje,
 * ver la función shouldComponentUpdate, donde se definen
 * aquellos estados que permiten actualizar el contenido.
 * De otro modo, el mensaje no actualizará su estado como
 * uno espera.
 */

class Message extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      avatar_shape: props.avatar_shape,
      // key: props.key,
      author: props.author,
      timestamp: props.data.timestamp || Date.now(),
      data: props.data,
      list: props.list,
      agentsInfo: props.agentsInfo,
      // Animation data
      animate: props.animate,
      typing$: props.data.typing,
      // Image messages (ghost message)
      url: (props.data.type === 'image') ? 
        (typeof props.data.url === 'string') ? 
          props.data.url : 
          this.getUrls([props.data.url])[0] :
        props.data.url, // iframe messages
      urls: (props.data.type === 'multiple_images') ?
        (typeof props.data.urls[0] === 'string') ?
          props.data.urls : 
          this.getUrls(props.data.urls) :
        [],
      avatarVisibility: true,
      eval: false,
      extraClass: props.data.extra ? (props.data.extra.extraClass || '') : '',
    };

    this.messageElement = null;
    this.messageInfo = null;
    this.messageContentRef = null;
    this.messageInnerContent = null;
    this.bubbleElem = null;
    this.motion = false;  // Animado
    this.mobileHA = props.mobileHA || false;
    this.engageEndFlag = false;
    this.animationsDelay = 500;
    this.ee = props.ee;
    this.setupListeners();

    this.scrollBottom = props.scrollBottom;
    this.fadeOut = this.fadeOut.bind(this);

    this.animations$ = props.author === 'brand' ?
      props.brandMessageAnimation$ :
      props.userMessageAnimation$;

    let subscription = null;
    if (this.props.animate)
      subscription = this.animations$.subscribe({
        next: step => {
          // En estos pasos hay que realizar las acciones del siguiente paso,
          // ya que representan el fin de dicho paso.
          switch (step) {
            // brand messages cases
            case 'bubble_left_in':
              // this.setUserMessageSize();
              break;
            case 'typing_on':
              break;
            case 'typing_off':
              this.setBubbleSize();
              break;
            case 'bubble_resize':
              break;
            // user messages cases
            case 'input_out':
              this.setUserMessageSize();
              break;
            case 'bubble_right_in':
              break;
            case 'bubble_resize':
              break;
            // common cases
            case 'flow_end':
              subscription.unsubscribe();
              break;
          }
        }
      });

    this.animations$.next(this.props.data);
  }

  // getUrl() {
  //   const { type, url, urls } = this.props.data;
  //   if (type === 'image') {
  //     return (typeof url === 'string') ? url : this.getUrls([url])[0];
  //   } else if (type === 'multiple_images') {
  //     // Si el tipo del primer elemento es string, ya es una url válida. De lo contrario es un File.
  //     return (typeof urls[0] === 'string') ? urls : this.getUrls(urls);
  //   }
  // }

  setupListeners() {
    const mounted$ = Observable.fromEvent(this.ee, 'hu-lb-message-mounted');
    const responded$ = Observable.fromEvent(this.ee, 'hu-lb-response-avatar-coords');

    const motion$ = Observable
      .merge(mounted$, responded$)
      .distinctUntilChanged()
      .pairwise()
      .map(a => a.filter((a) => a !== undefined)[0])
      .first()
      .subscribe({
        next: (coords) => {
          if (this.motion && !this.rendered) {
            this.rendered = true;
            this.setAvatarTranslation(coords);
          }
        }
      });
  }

  componentDidMount() {
    this.setupMountedListeners();
    this.ee.emit('hu-lb-message-mounted');

    // Un mensaje sin animaciones es renderizado 'on Mount'
    if (!this.motion)
      this.rendered = true;

    // Execute js injection
    if (!this.state.eval)
      this.executeScripts();
  }

  componentWillUnmount() {
    this.ee.removeListener('hu-reset-chat', this.fadeOut);
    // this.messageElement.style = '';
    // this.messageContentRef.style = '';
    // this.messageInnerContent.style = '';
    this.messageElement.removeAttribute('style');
    this.messageContentRef.removeAttribute('style');
    this.messageInnerContent.removeAttribute('style');
  }

  setupMountedListeners() {
    Observable.fromEvent(this.ee, 'hu-lb-query-avatar-coords')
      .subscribe({
        next: (key) => {
          if (!this.messageElement)
            return;
          if (key === this.state.data.key) {
            const coords = this.messageElement.offsetTop + this.messageElement.offsetHeight;
            this.ee.emit('hu-lb-response-avatar-coords', coords);
            // Siempre que alguien me pida las coordenadas, oculto mi avatar.
            this.setState({
              avatarVisibility: false,
            });
          }
        }
      });
    
    // Typing state
    const { typing$ } = this.state;
    const key = this.props.data.key;
    if (typing$) {
      typing$.subscribe({
        next: (v) => {
          if (v.key === key) {
            if (v.state === false) {
              
              Logger.append(
                [`%c${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Typing OFF`, 'color:blue'],
                `landbot.messages[${key}]`
              );

              // console.debug(`%cLandbot debug: Typing OFF <${this.props.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
              // this.setBubbleSize();
              this.ee.emit('hu-lb-bubble-typing-end');
            } else {

              Logger.append(
                [`%c${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Typing ON`, 'color:blue'],
                `landbot.messages[${key}]`
              );

              // console.debug(`%cLandbot debug: Typing ON <${this.props.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
              this.setState({
                typing$: v.state,
              });
            }
          }
        }
      });
    }
    // else  // Esto lo acabo de descomentar, veremos a ver...
    //   this.setBubbleSize();

    // Fade out on reset chat
    this.ee.on('hu-reset-chat', this.fadeOut);
  }

  fadeOut() {
    Velocity(
      this.messageElement,
      { opacity: 0 },
      { duration: 500 }
    );
  }
    
  DOMVirtualizer(elem) {
    if (elem instanceof Node === false)
      return null;

    switch (elem.nodeName) {
      case '#text':
        return elem.textContent;
        break;
      case 'SPAN':
        return (
          <span className={elem.className}>{elem.textContent}</span>
        );
        break;
      case 'A':
        return (
          <a className={elem.className} href={elem.href} target="_blank">{elem.textContent}</a>
        );
        break;
      case 'DIV':
        return (
          <div className={elem.className} dangerouslySetInnerHTML={{__html: elem.innerHTML}}></div>
        );
        break;
      case 'BR':
        return (
          <br />
        );
      default:
        break;
    }
  }

  /**
   * getUrls
   * @param {Array} files Array of files to be processed
   */
  getUrls(files) {
    let _urls = [];
    for (let i = 0; i < files.length; i++) {
      let reader = new FileReader();
      reader.readAsDataURL(files[i]);
      reader.onload = (e) => {
        _urls[i] = e.target.result;
        this.setState({
          url: _urls[0],
          urls: _urls,
        });
      }
    }
    return Array(files.length).fill(null);
  }

  messageEnvironment(key) {
    const { list } = this.props;
    const i = this.getMessageIndex(key);
    if (i === -1)
      return {
        prev: undefined,
        next: undefined,
      };
    else
      return {
        prev: list[i - 1],
        next: list[i + 1],
      };
  }

  getMessageIndex(key) {
    const { list } = this.props;
    let i = 0;
    for (i; i < list.length; i++) {
      if (list[i].key === key)
        return i;
    }
    return -1;
  }

  getInfoRelativeCoords(prevCoords) {
    if (!this.messageElement)
      return 0;
    return prevCoords - (this.messageElement.offsetTop + this.messageElement.offsetHeight);
  }

  setAvatarTranslation(prevCoords) {
    if (!this.messageInfo)
      return;
    // console.debug(`%cLandbot debug: Avatar shown <${this.props.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
    const elem = this.messageInfo;
    const value = this.getInfoRelativeCoords(prevCoords);
    elem.style.transition = 'transform 0ms';
    elem.style.visibility = 'hidden';
    elem.style.transform = `translateY(${value}px)`;
    elem.style.visibility = '';

    elem.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'transform') {
        this.ee.emit('hu-lb-avatar-translation-end');
      }
    })

    // Set timeout fix for next frame animation
    setTimeout(() => {
      elem.style.transition = 'transform .25s';
      elem.style.transform = 'translateY(0px)';
    }, 10);
  }

  setBubbleSize() {
    if (!this.bubbleElem)
      return;
    let elem = this.bubbleElem;

    // No animation in mobile
    // if (this.props.isMobile) {
    //   this.setState({
    //     typing$: false,
    //   }, () => {
    //     elem.style.width = 'auto';
    //     elem.style.height = 'auto';
    //     this.ee.emit('hu-lb-bubble-resize-end');
    //     this.messageInnerContent.style.display = 'inline-block';
    //     this.messageInnerContent.style.opacity = '1';
    //   });
    //   this.scrollBottom(250);
    //   return;
    // }

    // Usamos sandbox para calcular altura y anchura del elemento
    let parent = this.bubbleElem.parentElement;
    let parentWidth = getComputedStyle(parent).width;
    let vElem = document.createElement('div');
    vElem.className = this.props.data.extra ? (this.props.data.extra.extraClass || '') : '';
    // vElem.style.width = `${parseInt(parentWidth) - 32}px`; // 32 por el margen de 16 horizontal
    vElem.style.width = `${parseInt(parentWidth)}px`; // Probemos sin la resta
    let vTarget = elem.cloneNode(true);
    vTarget.className = vTarget.className.replace(/\styping/, '');
    vTarget.style.width = 'auto';
    vTarget.style.height = 'auto';
    vTarget.style.overflow = 'visible';
    vElem.appendChild(vTarget);
    document.getElementById('hu-msn-sandbox').appendChild(vElem);

    const width = getComputedStyle(vTarget).width;
    const height = getComputedStyle(vTarget).height;

    this.setState({
      typing$: false,
    }, () => {
      Velocity(
        elem,
        { width: width, height: height },
        { duration: 250, mobileHA: this.mobileHA, complete: () => {
          this.ee.emit('hu-lb-bubble-resize-end');
          Velocity(
            this.messageInnerContent,
            { opacity: 1 },
            { duration: 150, display: 'inline-block', mobileHA: this.mobileHA }
          );
          setTimeout(() => {
            elem.style.width = 'auto';
            elem.style.height = 'auto';
          }, 200)
        }}
      );
    });

    this.scrollBottom(250);
    document.getElementById('hu-msn-sandbox').innerHTML = '';
  }

  setUserMessageSize() {
    let elem = this.messageElement;

    const height = getComputedStyle(elem.childNodes[0]).height;
    Velocity(
      elem,
      { height: height },
      { duration: 350, mobileHA: this.mobileHA, complete: () => {
        this.ee.emit('hu-lb-bubble-resize-end');
        setTimeout(() => {
          elem.style.height = 'auto';
        }, 400);
      }}
    );

    this.scrollBottom(350);
  }

  executeScripts(div = this.messageInnerContent) {
    if (!div)
      return;
    if (!this.props.animate)
      return;
    const scripts = div.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++)
      eval(scripts[i].textContent);
    this.setState({
      eval: true,
    });
  }

  getElHeight(offset = 0) {
    let vTarget = document.createElement('p');
    document.getElementById('hu-msn-sandbox').appendChild(vTarget);
    let height = Math.floor(parseInt(getComputedStyle(vTarget).lineHeight)) + offset + 'px';
    document.getElementById('hu-msn-sandbox').innerHTML = '';
    return height;
  }

  /**
   * agentsInfo: {
   *  avatar: 
   *  name:
   * }
   */
  getAgent() {
    const { data, agentsInfo } = this.props;
    const defaultAvatar = `${UmiCoreConfig.staticUrl}landbot/files/lb-default-avatar.jpg`;
    const defaultName = `landbot`;
    if (data.samurai > 0)
      return agentsInfo[data.samurai] ?
        agentsInfo[data.samurai] :
        { avatar: defaultAvatar, name: defaultName };
    else
      return defaultAvatar;
  }

  onBubbleClick() {
    // Simulación de ArrowDown press para interrumpir el typing
    if (this.state.typing$)
      this.ee.emit('hu-lb-key-arrowdown');
  }

  getYoutubeURL(url) {
    let video_id = '';
    let result = '';
    let regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    let match = url.match(regExp);
    if (match && match[2].length == 11) {
      video_id = match[2];
      result = `https://www.youtube.com/embed/${video_id}`;
    }
    return result;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const changeStates = ['url', 'avatarVisibility', 'eval', 'extraClass', 'typing$'];
    let update = false;
    for (let i = 0; i < changeStates.length; i++) {
      if (this.state[changeStates[i]] !== nextState[changeStates[i]]) {
        // console.log(this.props.data.key);
        // console.log('STATE CHANGE')
        // console.log(changeStates[i])
        update = true;
      }
    }
    if (
      JSON.stringify(this.state.urls) !==
      JSON.stringify(nextState.urls)
    ) {
      // console.log(this.props.data.key);
      // console.log('URLS CHANGE')
      // console.log('urls')
      update = true;
    }

    const { data, avatar_shape } = this.props;
    const changeData = ['message', 'title'];
    for (let i = 0; i < changeData.length; i++) {
      if (this.props.data[changeData[i]] !== nextProps.data[changeData[i]]) {
        // console.log(this.props.data.key);
        // console.log('PROPS CHANGE')
        // console.log(changeData[i])
        update = true;
      }
    }
    if (this.props.avatar_shape !== nextProps.avatar_shape) {
      update = true;
    }
    if (
      JSON.stringify(this.props.agentsInfo) !==
      JSON.stringify(nextProps.agentsInfo)
    )
      update = true;
    if (
      JSON.stringify(this.props.data.role) !==
      JSON.stringify(nextProps.data.role)
    )
      update = true;

    return update;
  }

  componentDidUpdate(prevProps) {
    const key = this.props.data.key;
    // Send typing interruption when role is not engage anymore
    const _role = prevProps.data.role ? prevProps.data.role : [];
    const role_ = this.props.data.role ? this.props.data.role : [];
    
    if (_role.indexOf('engage') > -1 && role_.indexOf('engage') === -1) {
      if (this.props.data.type === 'image')
        this.setState({
          url: this.props.data.url,
        });
      if (this.props.data.type === 'multiple_images')
        this.setState({
          urls: this.props.data.urls,
        });

      this.ee.emit('hu-lb-engage-end');
      Logger.append(
        `${DateUtils.format(new Date(), 'HH:mm:ss.ff')}: Sent endEngage event`,
        `landbot.messages[${key}]`
      );

      this.executeScripts();
    }
  }

  render() {
    const ee = this.ee;
    const {
      avatar_shape,
      author,
      data,
      list,
      agentsInfo,
      animate,
    } = this.props;
    const {
      key,
      type,
      message,
      title,
      file_name,
      brand,
      url_referral,
    } = data;
    const {
      timestamp,
      typing$,
      // typingState,
    } = this.state;
    let { // Las urls pueden ser dinámicas, para el mensaje fantasma de usuario
      url,
      urls,
      avatarVisibility,
    } = this.state;
    const extraClass = data.extra ? (data.extra.extraClass || '') : '';

    // Si no hay timestamp, es generado con el instante actual
    const date = DateUtils.format(timestamp, 'HH:mm');

    // Rich Text
    const auxNode = document.createElement('p');
    let sections = null;

    // MESSAGE CONTENT
    let messageContent = null;
    switch(type) {
      case 'text':
        sections = richText.transform(auxNode, message);
        messageContent = (
          <p className={`hu-message-text ${author === 'brand' ? 'hu-color_bot-message-text' : 'hu-color_user-message-text'}`} ref={elem => {this.messageInnerContent = elem}}>
            {sections ? sections.map((elem) => this.DOMVirtualizer(elem)) : ''}
          </p>
        );
        break;
      case 'referral':
        // sections = richText.transform(auxNode, _message);
        messageContent = (
          <p className={`hu-message-text ${author === 'brand' ? 'hu-color_bot-message-text' : 'hu-color_user-message-text'}`} ref={elem => {this.messageInnerContent = elem}}>
            Feel free to share this landbot on:
            <div className="referral-buttons">
              <a href={SpecialUtils.getReferralUrl('facebook', { brand, url_referral })} target="_blank" className="menu-button referral-facebook hu-a-center hu-s-13">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#FFFFFF" d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />
                </svg>
                <span>Facebook</span>
                {/* <svg width="39px" height="75px" viewBox="0 0 39 75" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.664911685">
                    <path d="M38.9186184,0.540536367 C37.7024116,0.360357578 33.5132547,0 28.6484274,0 C18.4683259,0 11.4863978,6.21616822 11.4863978,17.6124766 L11.4863978,27.4322206 L0,27.4322206 L0,40.765451 L11.4863978,40.765451 L11.4863978,74.9543762 L25.2700751,74.9543762 L25.2700751,40.765451 L36.7114282,40.765451 L38.4681714,27.4322206 L25.2700751,27.4322206 L25.2700751,18.9187728 C25.2700751,15.0899736 26.3061032,12.4323364 31.8466009,12.4323364 L38.9186184,12.4323364 L38.9186184,0.540536367 Z" id="" fill="#6D89D2"></path>
                  </g>
                </svg> */}
              </a>
              <a href={SpecialUtils.getReferralUrl('twitter', { brand, url_referral })} target="_blank" className="menu-button referral-twitter hu-a-center hu-s-13">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#FFFFFF" d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />
                </svg>
                <span>Twitter</span>
                {/* <svg width="71px" height="58px" viewBox="0 0 71 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.260303442">
                    <path fill="#FFFFFF" d="M70.9904428,6.84679398 C68.3778504,7.97291141 65.5400345,8.78371596 62.6121292,9.09902884 C65.6301239,7.29724095 67.9274034,4.45942503 69.0084762,1.08107273 C66.2157049,2.74772653 63.0625761,3.96393336 59.7743132,4.59455912 C57.1166761,1.75674319 53.3329215,0 49.1437647,0 C41.0807639,0 34.5943275,6.5314811 34.5943275,14.5494372 C34.5943275,15.6755546 34.7294616,16.8016721 34.9546851,17.8827448 C22.8827062,17.252119 12.1170236,11.4863978 4.9549167,2.65763714 C3.69366517,4.8197826 2.97295002,7.29724095 2.97295002,9.99992279 C2.97295002,15.0449289 5.54049776,19.5043539 9.45938642,22.1169463 C7.07201747,22.0268569 4.8197826,21.3511865 2.88286062,20.2701138 L2.88286062,20.4502925 C2.88286062,27.52231 7.88282202,33.3781207 14.5494372,34.7294616 C13.3332304,35.0447744 12.0269342,35.2249532 10.7206379,35.2249532 C9.7746993,35.2249532 8.87380536,35.1348638 7.97291141,34.9997298 C9.819744,40.765451 15.180063,44.9546078 21.57641,45.0897419 C16.5764486,49.0086306 10.3152357,51.3059102 3.51348638,51.3059102 C2.29727956,51.3059102 1.17116213,51.2608655 0,51.1257314 C6.4413917,55.2698435 14.0989902,57.6572125 22.3421698,57.6572125 C49.09872,57.6572125 63.7382466,35.4952214 63.7382466,16.2611357 C63.7382466,15.6305099 63.7382466,14.9998842 63.6932019,14.3692584 C66.5310178,12.2972023 69.0084762,9.7296546 70.9904428,6.84679398 Z"></path>
                  </g>
                </svg> */}
              </a>
              <a href={SpecialUtils.getReferralUrl('linkedin', { brand, url_referral })} target="_blank" className="menu-button referral-linkedin hu-a-center hu-s-13">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#FFFFFF" d="M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z" />
                </svg>
                <span>LinkedIn</span>
                {/* <svg width="70px" height="70px" viewBox="0 0 70 70" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.664911685">
                    <path fill="#135386" d="M10.6755932,58.4245447 L21.0809183,58.4245447 L21.0809183,27.1635248 L10.6755932,27.1635248 L10.6755932,58.4245447 Z M21.7565888,17.5239596 C21.7115441,14.4609202 19.5043539,12.1185959 15.9458228,12.1185959 C12.3872917,12.1185959 10.0449675,14.4609202 10.0449675,17.5239596 C10.0449675,20.4969096 12.2972023,22.9293233 15.8106887,22.9293233 L15.8557334,22.9293233 C19.5043539,22.9293233 21.7565888,20.4969096 21.7565888,17.5239596 Z M37.2069199,31.5701938 L37.2069199,31.7130392 L37.1168305,31.7130392 C37.1463173,31.6658604 37.1763402,31.6182312 37.2069199,31.5701938 L37.2069199,31.5701938 Z M37.2069199,31.5701938 L37.2069199,27.1635248 L26.8015949,27.1635248 C26.8015949,27.1635248 26.9367289,30.0914301 26.8015949,58.4245447 L37.2069199,58.4245447 L37.2069199,40.9472022 C37.2069199,40.0463082 37.2519646,39.1003696 37.5222328,38.4246991 C38.2879927,36.5778665 39.9996911,34.6409446 42.8825518,34.6409446 C46.6212616,34.6409446 48.1077366,37.4787605 48.1077366,41.712962 L48.1077366,58.4245447 L58.5130617,58.4245447 L58.5130617,40.4967552 C58.5130617,30.9022347 53.3779662,26.4428097 46.5311722,26.4428097 C41.0675084,26.4428097 38.5777694,29.4167345 37.2069199,31.5701938 L37.2069199,31.5701938 Z M69.188655,13.4699369 L69.188655,56.7128462 C69.188655,63.8749531 63.377889,69.685719 56.2157822,69.685719 L12.9728728,69.685719 C5.81076594,69.685719 0,63.8749531 0,56.7128462 L0,13.4699369 C0,6.30783 5.81076594,0.49706406 12.9728728,0.49706406 L56.2157822,0.49706406 C63.377889,0.49706406 69.188655,6.30783 69.188655,13.4699369 Z"></path>
                  </g>
                </svg> */}
              </a>
              <a href={SpecialUtils.getReferralUrl('whatsapp', { brand, url_referral })} target="_blank" className="menu-button referral-whatsapp hu-a-center hu-s-13">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#FFFFFF" d="M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
                </svg>
                <span>WhatsApp</span>
                {/* <svg width="70px" height="70px" viewBox="0 0 70 70" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <g id="Web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.664911685">
                    <path fill="#01A233" d="M44.3690268,38.6048779 C45.1347866,38.6048779 52.4770723,42.4336772 52.7923852,42.9742136 C52.8824746,43.199437 52.8824746,43.4697052 52.8824746,43.649884 C52.8824746,44.7760014 52.522117,46.037253 52.1167147,47.073281 C51.0806867,49.595784 46.8915298,51.2173931 44.3239821,51.2173931 C42.1618366,51.2173931 37.7024116,49.3255159 35.7654896,48.4246219 C29.3240979,45.4967166 25.3151198,40.4967552 21.4412759,34.7760787 C19.7295774,32.2535756 18.1980577,29.1454915 18.2431024,26.0374074 L18.2431024,25.6770498 C18.3331918,22.7040998 19.4142645,20.586999 21.57641,18.5599877 C22.2520804,17.9293619 22.9727956,17.5690043 23.9187342,17.5690043 C24.4592706,17.5690043 24.999807,17.7041384 25.585388,17.7041384 C26.8015949,17.7041384 27.0268183,18.064496 27.4772653,19.2356581 C27.7925782,20.001418 30.0898578,26.1274968 30.0898578,26.5779438 C30.0898578,28.2896423 26.9817736,30.2265642 26.9817736,31.2625923 C26.9817736,31.4878158 27.071863,31.7130392 27.2069971,31.9382627 C28.1979805,34.0553635 30.0898578,36.4877772 31.8015562,38.1093863 C33.8736123,40.0913529 36.0808025,41.3976492 38.6033055,42.6589007 C38.9186184,42.8390795 39.2339313,42.9742136 39.5942889,42.9742136 C40.9456298,42.9742136 43.1978646,38.6048779 44.3690268,38.6048779 Z M35.2249532,62.4785675 C50.8104185,62.4785675 63.5130231,49.7759628 63.5130231,34.1904976 C63.5130231,18.6050323 50.8104185,5.90242773 35.2249532,5.90242773 C19.639488,5.90242773 6.93688337,18.6050323 6.93688337,34.1904976 C6.93688337,40.1363976 8.82876066,45.9471636 12.342247,50.7669462 L8.78371596,61.2623606 L19.6845327,57.7939189 C24.2790918,60.8119137 29.7295002,62.4785675 35.2249532,62.4785675 Z M35.2249532,0.226795877 C53.9635473,0.226795877 69.188655,15.4519035 69.188655,34.1904976 C69.188655,52.9290916 53.9635473,68.1541993 35.2249532,68.1541993 C29.5042767,68.1541993 23.8286448,66.712769 18.7836387,63.9199978 L0,69.9559872 L6.12607882,51.7128848 C2.92790532,46.4426552 1.26125152,40.3616211 1.26125152,34.1904976 C1.26125152,15.4519035 16.4863592,0.226795877 35.2249532,0.226795877 Z" ></path>
                  </g>
                </svg> */}
              </a>
            </div>
          </p>
        );
        break;
      case 'dialog':
      case 'menu':
        sections = richText.transform(auxNode, title);
        messageContent = (
          <p className={`hu-message-text ${author === 'brand' ? 'hu-color_bot-message-text' : 'hu-color_user-message-text'}`} ref={elem => {this.messageInnerContent = elem}}>
            {sections ? sections.map((elem) => this.DOMVirtualizer(elem)) : ''}
          </p>
        );
        break;
      case 'image':
        messageContent = (
          <div className={`hu-message-image`} ref={elem => {this.messageInnerContent = elem}}>
            { url !== null &&
              <a className="image-anchor" href={url} target="_blank">
                <img src={url} alt={file_name}/>
              </a>
            }
          </div>
        );
        break;
      case 'multiple_images':
        messageContent = (
          <div className={`hu-message-image`} ref={elem => {this.messageInnerContent = elem}}>
            { urls.map((url) => {
              if (url !== null) {
                return (
                  <a className="image-anchor" href={url} target="_blank">
                    <img src={url} alt={file_name}/>
                  </a>
                );
              } else 
                return null;
            })}
          </div>
        );
        break;
      case 'iframe':
        messageContent = (
          <div className={`hu-message-iframe`} ref={elem => {this.messageInnerContent = elem}}>
            { data.url &&
              <iframe type="text/html" width="640" height="360" src={this.getYoutubeURL(data.url)} frameborder="0"></iframe>
            }
          </div>
        );
        break;
    }

    // MESSAGE ANIMATIONS
    const { prev, next } = this.messageEnvironment(key);
    const motion = this.motion;
    const rendered = this.rendered;
    let left_in = false;
    let splitter = false;
    let _coords = 0;
    let _avatarVisibility = avatarVisibility;
    const isAgent = data.samurai > 0;
    const agent = this.getAgent();

    if (animate && author === 'brand') {
      /**
       * Mensajes de brand
       * 
       * Pasos:
       * left_in -> true si mensaje anterior == user
       * avatarVisibility -> true si mensaje posterior == user
       */
      if (prev !== undefined) {
        if (prev.author === 'user') {
          left_in = true;
        } else if (prev.author === 'brand') {
          if (prev.data.samurai !== data.samurai) {
            left_in = true;
          } else {
            left_in = false;
            ee.emit('hu-lb-avatar-translation-end');
          }
          // AVATAR MOVES
          if (!rendered && !motion)
            this.motion = true;
          ee.emit('hu-lb-query-avatar-coords', prev.key);
        }
      } else 
        left_in = true;
    } else if (animate && author === 'user') {
      /**
       * Mensajes de user
       */
    }

    // La visibilidad del avatar no depende de "animate"
    if (next !== undefined) {
      if (next.author === 'user') {
        _avatarVisibility = true;
      } else if (next.author === 'brand') {
        if (data.samurai !== next.data.samurai) {
          _avatarVisibility = true;
          splitter = true;
        }
        else {
          _avatarVisibility = false;
        }
      }
    }

    const animateNames = [
      'animate',
      'left-in',
    ];
    const animateClasses = [
      animate,
      left_in,
    ]
      .map((item, i) => item ? animateNames[i] : false)
      .filter((item) => item)
      .join(' ');

    // MESSAGE RENDER
    return (
      <div 
        id={key}
        className={`hu-message ${author} ${animateClasses} ${extraClass}${splitter ? ' splitter': ''}`}
        data-author={``}
        ref={(msg) => {this.messageElement = msg}}
      >
        <div className="hu-message-container">
          <div className="hu-message-margin">
            <div 
              className={`hu-message-info${_avatarVisibility ? ' visible' : ''}`}
              ref={(elem) => {this.messageInfo = elem;}}
            >
              { author === 'brand' &&
                <div 
                  className={`hu-message-avatar hu-background-color_contrast-fade ${avatar_shape}${isAgent ? ' agent' : ''}`}
                  style={isAgent ? { backgroundImage: `url(${agent.avatar})` } : {}}
                ></div>
              }
              <div className="hu-message-date hu-a-center hu-s-10 hu-color_contrast">
                <span>
                  {isAgent ? agent.name : date}
                </span>
              </div>
            </div>
            <div 
              className={`hu-message-content`}
              ref={elem => {this.messageContentRef = elem}}
            >
              <div 
                className={`hu-message-bubble${typing$ ? ' typing' : ''}${author === 'brand' ? ' hu-background-color_bot-message-background' : ' hu-background-color_user-message-background'}`}
                ref={(elem) => {this.bubbleElem = elem;}}
                onClick={this.onBubbleClick.bind(this)}
              >
                { author === 'brand' && 
                  <div className="typing-spinner" style={{ height: this.getElHeight(), width: typing$ ? 'auto' : 0 }}>
                    <div className="ball hu-background-color_accent"></div>
                    <div className="ball hu-background-color_accent"></div>
                    <div className="ball hu-background-color_accent"></div>
                  </div>
                }
                {messageContent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Message;


// WEBPACK FOOTER //
// ./app/js/components/messenger/Message.js